import { useCollectionServices } from 'hooks';
import services from 'services';

const useHeaderItems = () => useCollectionServices(services.appFrame.header);

export default useHeaderItems;
